import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { AspenLeaf } from 'types/aspen/leaf';
import { AppLeaf } from 'types/common/leaf';

interface AspenSocketsParams {
  baseUrl: string;
}

interface FetchStreamInfoParams {
  leafId: AppLeaf['id'];
  leafType: AppLeaf['type'];
}

export type SignalingData = {
  signalingUrl: string;
  signalToken: string;
};

export type StreamInfo = {
  deviceId: AppLeaf['id'];
  servers: Array<RTCIceServer & { url: RTCIceServer['urls'] }>;
  signaling: SignalingData;
};

export const aspenSockets = ({ baseUrl }: AspenSocketsParams) => {
  const fetchLeaves = async (): Promise<Array<AspenLeaf>> => {
    const response = await axios.get(`/${baseUrl}/api/v1/leaves`, {
      headers: {
        'x-request-id': uuidv4(),
      },
    });
    return response.data;
  };

  const fetchStreamInfo = async ({ leafId, leafType }: FetchStreamInfoParams): Promise<StreamInfo> => {
    const response = await axios.get(`/${baseUrl}/api/v1/leaves/${leafId}/streams?leafType=${leafType}`, {
      headers: { 'x-request-id': uuidv4() },
    });
    // Returns an array with a single element
    const { deviceId, servers, signalingUrl, signalToken } = response.data[0];
    return {
      deviceId,
      servers,
      signaling: {
        signalingUrl,
        signalToken,
      },
    };
  };

  const extractWebRTCSession = (signalingUrl: string): string => {
    const url = new URL(signalingUrl);
    return url.searchParams.get('session') as string;
  };

  return {
    extractWebRTCSession,
    fetchLeaves,
    fetchStreamInfo,
  };
};
